module.exports = __webpack_public_path__ + "static/coachella-texture-paper-3f91f759abe6d75d87b1311b29d660a9.png";